import type { ReactNode } from "react";

import { Icon } from "@/components/common/Icon";

interface FieldProps {
  label: string;
  hint?: string;
  required?: boolean;
  children: ReactNode;
}

export function Field({ label, hint, required, children }: FieldProps) {
  return (
    <div className="onb-field">
      <label className="onb-field-label">
        {label}
        {required && <span className="onb-field-req">*</span>}
      </label>
      {children}
      {hint && <div className="onb-field-hint">{hint}</div>}
    </div>
  );
}

interface CheckboxProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  children: ReactNode;
}

export function Checkbox({ checked, onChange, children }: CheckboxProps) {
  return (
    <label className="onb-checkbox">
      <span
        className={`onb-checkbox-box ${checked ? "is-on" : ""}`}
        onClick={() => onChange(!checked)}
      >
        {checked && <Icon name="check" size={12} stroke={3} />}
      </span>
      <span className="onb-checkbox-text">{children}</span>
    </label>
  );
}
